module.exports = __webpack_public_path__ + "5f5766c9476758591c6885cfadf3fa38.png";